import React from 'react';
import Firebase from 'firebase';
import Item from './item'


export default class row extends React.Component {
    constructor() {
        super();
        this.state = {
            data: [],
            checkOutGPS: {},
            local: {}
        }
    }


    componentDidMount() {
        var data = new Array();
        const contex = this;
        var ref = "saved/" + localStorage.client_id + "/" + this.props.form + "/3/raw/data";
        if (this.props.num_days > (this.props.day + 1)) {
            var init = new Date(this.props.year, (this.props.month - 1), this.props.day).getTime();
            var end = new Date(this.props.year, (this.props.month - 1), (this.props.day + 1)).getTime();
            var dataRef = Firebase.database().ref("saved/" + localStorage.client_id + "/" + this.props.form + "/3/raw/data");
            dataRef.orderByChild("global/date/device").startAt(init).endAt(end)
                .once('value').then(snap => {
                    var data = [];
                    snap.forEach(function (childSnapshot) {
                        if (childSnapshot.val().global.user.rut === contex.props.user.value) {
                            data.push(childSnapshot.val())
                        }
                    });
                    this.setState({ data: data })
                })
        } else {
            var init = new Date(this.props.year, (this.props.month - 1), this.props.day).getTime();
            var dataRef = Firebase.database().ref("saved/" + localStorage.client_id + "/" + this.props.form + "/3/raw/data");
            dataRef.orderByChild("global/date/device").startAt(init)
                .once('value').then(snap => {
                    var data = [];
                    snap.forEach(function (childSnapshot) {
                        if (childSnapshot.val().global.user.rut === contex.props.user.value) {
                            data.push(childSnapshot.val())
                        }
                    });
                    this.setState({ data: data })
                })
        }
    }

    componentWillUpdate(nextProps, nextState) {
        const contex = this;
        if (nextState.data !== this.state.data && nextState.data.length > 0) {
            var num = 0;
            nextState.data.map((d) => {
                if (d.results.marcaje === "check-in") {
                    this.setState({ checkIn: d.global.date.device, checkInGPS: d.global.gps });
                } else if (d.results.marcaje === "check-out") {
                    this.setState({ checkOut: d.global.date.device, checkOutGPS: d.global.gps });
                }
                if (d.results.local) {
                    var gps_store = {};
                    var storeRef = Firebase.database().ref("stores/" + localStorage.client_id).orderByChild("0000_codloc").equalTo(d.results.local).once("value").then(resp => {
                        contex.setData(resp.val(), "local");
                        contex.setData(resp.val(), "Lat");
                        contex.setData(resp.val(), "Long");
                    });
                }
            });
        }
    }

    setData(obj, option) {
        const contex = this;
        var local = this.state.local ? this.state.local : {};
        Object.keys(Object.values(obj)[0]).map((o, index) => {
            var tt = o.substring(o.indexOf("_") + 1);
            if (tt === option) {
                local[option] = Object.values(Object.values(obj)[0])[index];
                contex.setState({ local: local });
                return local;
            }
        })
    }

    DateToFormattedString(timeStamp) {
        var d = new Date(timeStamp)
        var yyyy = d.getFullYear().toString();
        var mm = (d.getMonth() + 1).toString();
        var dd = d.getDate().toString();
        var hh = d.getHours().toString();
        var mn = d.getMinutes().toString();
        return (hh[1] ? hh : "0" + hh[0]) + ':' + (mn[1] ? mn : "0" + mn[0]);
    };

    render() {
        return (
            <td onClick={() => { this.props.callBack(this.state.data) }}>
                <Item local={this.state.local} checkIn={this.state.checkIn} checkInGPS={this.state.checkInGPS}
                    checkOut={this.state.checkOut} checkOutGPS={this.state.checkOutGPS}
                    />
            </td>
        );
    }
}


// WEBPACK FOOTER //
// ./src/views/control_de_asistencia/row.js